import gql from "graphql-tag";

export const MULTI_EDIT = gql`
	mutation multiEdit($input: MultiEditInput!) {
    multiEdit(input: $input) {
        documentId
        message
        error
    }
}
`;
